// extracted by mini-css-extract-plugin
export var searchHeader = "_6p-0";
export var searchHeaderDark = "_6p-1";